// extracted by mini-css-extract-plugin
export var section = "video-section-module--section--3TZHz";
export var snowflakes = "video-section-module--snowflakes--RFeH-";